import React from "react";
import "./SkeletonPost.css";

const SkeletonPost = () => {
  return (
    <div className="skeleton-post">
      {/* Header */}
      <div className="skeleton-header">
        <div className="skeleton-avatar shimmer" />
        <div className="skeleton-user-info">
          <div className="skeleton-line short shimmer" />
          <div className="skeleton-line xshort shimmer" />
        </div>
      </div>

      {/* Media */}
      <div className="skeleton-media shimmer" />

      {/* Actions */}
      <div className="skeleton-actions">
        <div className="skeleton-icon shimmer" />
        <div className="skeleton-icon shimmer" />
        <div className="skeleton-icon shimmer" />
        <div className="skeleton-rating">
          <div className="skeleton-line xxshort shimmer" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonPost;
